export default __webpack_public_path__ + "static/media/Image-8.8a4a4ea9.jpg";